var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.19C20 17.83 17.83 20 14.19 20H13C12.45 20 12 19.55 12 19V13.23C12 12.96 12.22 12.73 12.49 12.73L14.25 12.7C14.39 12.69 14.51 12.59 14.54 12.45L14.89 10.54C14.92 10.36 14.78 10.19 14.59 10.19L12.46 10.22C12.18 10.22 11.96 10 11.95 9.73001L11.91 7.28C11.91 7.12 12.04 6.98001 12.21 6.98001L14.61 6.94C14.78 6.94 14.91 6.81001 14.91 6.64001L14.87 4.23999C14.87 4.06999 14.74 3.94 14.57 3.94L11.87 3.98001C10.21 4.01001 8.89001 5.37 8.92001 7.03L8.97 9.78C8.98 10.06 8.76001 10.28 8.48001 10.29L7.28 10.31C7.11 10.31 6.98001 10.44 6.98001 10.61L7.01001 12.51C7.01001 12.68 7.14 12.81 7.31 12.81L8.51001 12.79C8.79001 12.79 9.00999 13.01 9.01999 13.28L9.10999 18.98C9.11999 19.54 8.66999 20 8.10999 20H5.81C2.17 20 0 17.83 0 14.18V5.81C0 2.17 2.17 0 5.81 0H14.19C17.83 0 20 2.17 20 5.81V14.19Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/Social-Facebook.63c931060cb81f0927274ecd2b16503a.svg";
export { ForwardRef as ReactComponent };